var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}})
}
var staticRenderFns = []

export { render, staticRenderFns }